import React from 'react';

import './infoBlock.scss';

export const InfoBlock = ({ data }) => (
  <section className="info-block">
    <div className="container" dangerouslySetInnerHTML={{ __html: data }} />
  </section>
);
